module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-video"
  }, [_c('div', {
    on: {
      "~click": function($event) {
        _vm.embed($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.embedded) ? _c('div', {
    staticClass: "sky-video-iframe"
  }, [_c('iframe', {
    attrs: {
      "frameborder": "0",
      "allowfullscreen": "allowfullscreen",
      "src": _vm.iframeSrc
    }
  })]) : _c('div', {
    staticClass: "sky-video-poster",
    style: (_vm.iframePoster)
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-video-click"
  }, [_c('label', [_c('button', {
    staticClass: "sky-video-play"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-566683b0"}!./scripts/sky-video/sky-video.html
// module id = 366
// module chunks = 1